export const reservationErrorMessage = (error, fallback) => {
  const detail = error.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    if (detail.some((item) => item.loc?.includes("adults_count"))) {
      return "Bitte mindestens eine erwachsene Person als ganze Zahl erfassen.";
    }
    if (detail.some((item) => item.loc?.includes("children_count"))) {
      return "Bitte die Kinderanzahl als ganze Zahl ab 0 erfassen.";
    }
    return "Bitte überprüfen Sie Ihre Eingaben.";
  }
  return fallback;
};